<template>
  <div class="ui-box-item">
    <titleComponents :show.sync="show" name="基础信息"></titleComponents>
    <div class="itemInfo-detail" v-show="show">
      <div class="baseInfo-content">
        <div class="text">妈妈姓名：{{data.tbMotherName||'-'}}</div>
        <div class="text">爸爸姓名：{{data.tbFatherName||'-'}}</div>
        <div class="text">宝宝状态：{{data.tbBabyState===1?'未出生':'已出生'}}</div>
        <div class="text">宝宝{{data.tbBabyState===1?'预产期':'生日'}}：{{new Date(data.tbBirthday).format('yyyy-MM-dd')}}</div>
      </div>
      <div class="baseInfo-content">
        <div class="text">宝宝姓名：{{data.tbBabyName||'-'}}</div>
        <div class="text">宝宝小名：{{data.tbBabyNickName||'-'}}</div>
        <div class="text">宝宝性别：{{data.tbBabySex===1?'男':'女'}}</div>
        <div class="text">宝宝八字：{{data.tbEightChar||'-'}}</div>
      </div>
      <div class="baseInfo-content">
        <div class="text">出生体长：{{data.tbHeight||'-'}}</div>
        <div class="text">出生体重：{{data.tbWeight||'-'}}</div>
        <div class="text">宝宝生肖：{{data.tbZodiac||'-'}}</div>
        <div class="text">宝宝星座：{{data.tbConstellation||'-'}}</div>
      </div>
      <div class="baseInfo-content">
        <div class="text">妈妈寄语：{{data.tbMotherRemark||'-'}}</div>
      </div>
      <div class="baseInfo-content">
        <div class="text">爸爸寄语：{{data.tbFatherRemark||'-'}}</div>
      </div>
      <div class="baseInfo-content">
        图片列表：
        <upload :uploadSize="104" :downLoad="true" :multiple="true" :isSee="true" :isPic="true" :limit="1" :fileList.sync="data.tbImagesTemp" validateRef="tbImages" @onSuccess="uploadSuccess" :saveFileList.sync="data.tbImages"></upload>
      </div>
    </div>
  </div>
</template>
</template>

<script>
import upload from '@/components/upload/upload.vue'
import titleComponents from '@/components/mother/title'
export default {
  name: 'baseInfo',
  props: {
    data: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      show: true
    }
  },
  created () {

  },
  computed: {
  },
  methods: {
    uploadSuccess (ref) {
      this.$refs['form'].validateField(ref)
    },
  },
  components: {
    titleComponents,
    upload
  }
}
</script>

<style lang="scss" scoped>
.ui-box-item {
  margin: 20px 24px 0;
  background: rgba(0, 0, 0, 0.02);
  box-sizing: border-box;
  width: calc(100% - 48px);
  .itemInfo-detail {
    border-top: 1px solid #e5e5e5;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    .baseInfo-content {
      display: flex;
      align-content: center;
      margin-bottom: 25px;
      .text {
        width: 250px;
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        line-height: 22px;
        margin-right: 60px;
      }
    }
  }
}
</style>
     